module.exports = __webpack_public_path__ + "static/media/login-bg.b164f405.jpg";